(function ($)
{
    var mFileSearchObjectCounter = 0;

    $.widget("ui.FileSearch",
        {
            options:
            {
                PageContentId: null,
                InitialPagerData: null,
                FileResultSelector: '.file_list_result.file',
                ResultListSelector: '.file_search_results',
                MoreWrapperSelector: '.file_list',
                FileGallerySelector: '.file_search_results',
                LinkedFileClass: 'fbcms_linkedfile'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
                VideoUtilities.SetupVideoResizer('.filemedia_video');
            },

            _MyObjectNumber: null,

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);
                if (self.options.PageContentId === null)
                {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedFileClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.FileGallerySelector))
                {
                    FBUtilities.LogMessage('FileList - required settings null or empty.');
                    return;
                }

                mFileSearchObjectCounter = mFileSearchObjectCounter += 1;
                self._MyObjectNumber = mFileSearchObjectCounter;

                const fileSearchResultId = 'FileSearchResult' + self._MyObjectNumber;
                const jResultsContainer = jElement.find(self.options.ResultListSelector);

                jResultsContainer.attr('role', 'region');
                jResultsContainer.attr('aria-live', 'polite');
                jResultsContainer.attr('id', fileSearchResultId);

                self.SetupFileButtons();
                self.SetupPagination();

                const jSearchButton = jElement.find('.search_button');
                jSearchButton.on('click', function (aEvent)
                {
                    aEvent.preventDefault();
                    self.Search();
                    return false;
                });
                jSearchButton.attr('aria-controls', fileSearchResultId);

                const jResetButton = jElement.find('.reset_button');
                jResetButton.on('click', function (aEvent)
                {
                    aEvent.preventDefault();
                    self.Reset();
                    return false;
                });
                jResetButton.attr('aria-controls', fileSearchResultId);

                const jFilterSearchText = jElement.find('input[name="SearchText"]');
                jFilterSearchText.attr('aria-controls', fileSearchResultId);
                jFilterSearchText.on(
                    'keypress',
                    function (aEvent)
                    {
                        if (aEvent.key === "Enter")
                        {
                            aEvent.preventDefault();
                            self.Search();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

                this._ConfigDatePicker(fileSearchResultId, '#ModifiedAfter', '#ModifiedBefore');
            },

            _ConfigDatePicker: function (lFileSearchResultId, startDateSelector, endDateSelector)
            {
                const self = this;
                const jElement = $(self.element);

                const jFilterStartDate = jElement.find(startDateSelector);
                const jFilterEndDate = jElement.find(endDateSelector);

                if (jFilterStartDate.length === 1 && jFilterEndDate.length === 1)
                {
                    const checkDatePickers = function (aStartModified)
                    {
                        const startText = jFilterStartDate.val();
                        const endText = jFilterEndDate.val();
                        if (startText.length !== 0 && endText.length !== 0)
                        {
                            const startDate = new Date(startText);
                            const endDate = new Date(endText);

                            if (startDate > endDate)
                            {
                                if (aStartModified === true)
                                {
                                    jFilterEndDate.val(startText);
                                }
                                else
                                {
                                    jFilterStartDate.val(endText);
                                }
                            }
                        }
                    };

                    jFilterStartDate.FBDateSelector({
                        ClearInputButtonLabel: 'Clear Start Date'
                        , OnChangeCallback: function (_event) {checkDatePickers(true);}
                    });

                    jFilterEndDate.FBDateSelector({
                        ClearInputButtonLabel: 'Clear End Date',
                        OnChangeCallback: function (_event) {checkDatePickers(false);}
                    });

                    jFilterStartDate.attr('aria-controls', lFileSearchResultId);
                    jFilterEndDate.attr('aria-controls', lFileSearchResultId);

                    jFilterStartDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                    jFilterEndDate.on(
                        'keypress',
                        function (aEvent)
                        {
                            if (aEvent.key === "Enter")
                            {
                                aEvent.preventDefault();
                                self.Search();
                                return false;
                            }
                            // nevermind, carry on...
                            return true;
                        }
                    );
                }
            },
            Reset: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.file_search_form');

                // reset all input fields.
            jFormDiv.find('input[name="SearchText"]').val('');
                jFormDiv.find('#ModifiedAfter').val('');
                jFormDiv.find('#ModifiedBefore').val('');
                jFormDiv.find('input[name=SelectedItems]').prop('checked', false);
            jElement.find('.file_search_form').find('input[name="IsReset"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            GetSearchData: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.file_search_form');

                const searchData = {
                    "PageContentId": self.options.PageContentId,
                "FromFileSearchForm": jFormDiv.find('input[name="IsNewSearch"]').val(),
                "ResetFileSearchForm": jFormDiv.find('input[name="IsReset"]').val(),
                "SearchText": jFormDiv.find('input[name="SearchText"]').val(),
                    "ModifiedAfter": jFormDiv.find('#ModifiedAfter').val(),
                    "ModifiedBefore": jFormDiv.find('#ModifiedBefore').val(),
                    "SelectedItems": jFormDiv.find('input[name=SelectedItems]:checked')
                        .map(function () {return $(this).val();})
                        .get().join(',')
                };

            jFormDiv.find('input[name="IsNewSearch"]').val('');
            jFormDiv.find('input[name="IsReset"]').val('');

                return searchData;
            },

            Search: function ()
            {
                const self = this;
                const jElement = $(self.element);

            jElement.find('.file_search_form').find('input[name="IsNewSearch"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            SetupPagination: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const fileSearchResultId = 'FileSearchResult' + self._MyObjectNumber;
                const jResultsContainer = jElement.find(self.options.ResultListSelector);
                const jMoreContainter = jResultsContainer.find(self.options.MoreWrapperSelector);

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Files/Search/${self.options.PageContentId}/`,
                        LoadingTitle: "File Search",
                        NormalContainer: jResultsContainer,
                        MoreContainer: jMoreContainter,
                        OnSuccess: function (mode, data, textStatus, jqXHR)
                        {
                            self.SetupFileButtons();
                        },
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function ()
                        {
                            return self.GetSearchData();
                        },
                        LiveRegionId: fileSearchResultId
                    });
            },

            SetupFileButtons: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jGallery = jElement.find(self.options.FileGallerySelector);
                const jContainer = jElement.find(self.options.ResultListSelector);
                const jFiles = jContainer.find(self.options.FileResultSelector);
                const jControlledFileBlock = $('.fbcms_file_block');
                jFiles.addClass(self.options.LinkedFileClass);

                $.each(
                    jFiles,
                    function (aIndex, aValue)
                    {
                        const jFile = $(aValue);
                        const jLinkElement = jFile.find('[data-file-id]');
                        const url = jLinkElement.data('href');
                        if (FBUtilities.IsParameterUndefinedOrNull(url))
                        {
                            if (jControlledFileBlock.length > 0)
                            {
                                jLinkElement.attr('aria-controls', jControlledFileBlock.attr('id'));
                            }
                        }
                    }
                );
            }
        });
})(jQuery);
